module.exports = __webpack_public_path__ + "img/default-user-image.39132ce0.jpg";